export default "/images/mydev-dark.svg?a75bee55658b1c53372130fe864456f9";